var render = function (_h,_vm) {var _c=_vm._c;return _c('transition',{attrs:{"name":_vm.props.transition}},[(_vm.props.visible)?_c('div',{ref:"overlay",class:[_vm.data.class, _vm.data.staticClass, 'moomin-overlay'],on:{"click":function($event){_vm.listeners.click && _vm.listeners.click($event)}}}):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }